import { html, LitElement, css, unsafeCSS } from 'lit';

import style from './discorduser.scss';
import { imageToEmoji } from '../shared/utils';

export class DiscordUserComponent extends LitElement {

    static get properties() {
        return {
            user: String,
            awards: Object
        }
    }

    constructor() {
        super();
        this.user = '';
        this.awards = null;
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    attributeChangedCallback(name,old_value,new_value){        
        if(name === 'user'){
            this.fetchData(new_value);
        }
    }

    async fetchData(user) {  
        this.user = user;     
        this.awards = null;                 
        if(!user){
            return;
        }
        let json = await fetch(`./api/userawards/${user}`);
        this.awards = await json.json();          
    }

    render() {
        return html`
        <a href='./user/${encodeURIComponent(this.user)}'><img loading="lazy" src="./images/disc.svg" alt=${this.user} /> ${this.user?.replace(/_/g,' ')}</a>${this.awards?.map(award=>html`<div style="display:inline-block;cursor:help;font-size:18px;vertical-align:middle;" title=${award.name}>${imageToEmoji(award.image,true)}</div>`)}
        `;
    }
}

customElements.define('discorduser-component', DiscordUserComponent);